import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import ViralReferralWidget from '../components/ViralReferralWidget';
import { ArrowLeft, Sparkles } from 'lucide-react';

const InvitePage = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC]" data-testid="invite-page">
      <Header />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <Link to="/" className="text-xs text-slate-400 hover:text-[#E07A3A] tracking-wider uppercase flex items-center gap-1 mb-6">
          <ArrowLeft className="h-3 w-3" /> Back
        </Link>

        <div className="mb-8">
          <span className="text-xs tracking-[0.3em] text-[#E07A3A] mb-1 block uppercase font-medium flex items-center gap-2">
            <Sparkles className="h-3 w-3" /> Ambassador Programme
          </span>
          <h1 className="font-['Playfair_Display'] text-3xl sm:text-4xl text-[#1A1A1A] mb-2">Invite & Unlock</h1>
          <p className="text-slate-500 text-sm max-w-2xl">
            Invite friends to Shopperden and level up your Ambassador rank. Each milestone unlocks real product perks — priority boosts, unlimited AI floor plans, custom profile themes, exclusive titles, and early access to new features.
          </p>
        </div>

        <ViralReferralWidget />

        <div className="mt-10 bg-[#0F172A] text-white p-6 sm:p-8">
          <h3 className="font-['Playfair_Display'] text-xl mb-3">How the Ladder Works</h3>
          <div className="grid sm:grid-cols-3 gap-6 text-sm">
            <div>
              <p className="text-[#E07A3A] font-bold mb-1">1. Share your link</p>
              <p className="text-white/60">Copy your code or share directly via WhatsApp, Facebook, Twitter, email or SMS.</p>
            </div>
            <div>
              <p className="text-[#E07A3A] font-bold mb-1">2. Climb the ladder</p>
              <p className="text-white/60">Each signup earns XP and ticks you towards the next unlock tier. Qualified referrals earn bonus XP.</p>
            </div>
            <div>
              <p className="text-[#E07A3A] font-bold mb-1">3. Unlock perks</p>
              <p className="text-white/60">Priority boosts, unlimited AI tools, golden profile theme, "Property Insider" title, Founder's Lounge access, and more. No cash — pure engagement.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvitePage;
